// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonScrollTop_root__4dI9x"};